module.exports = __webpack_public_path__ + "img/free-fire.bc7cf230.png";